// RGR16 표에서 자유 입력으로 여는 컬럼 — 생성본(handoff/page.generated.tsx)은 이 칸들을 표시 전용으로 둔다.
// 1.0 RGR01 은 MUSINSATRADING 화주 설정에서 이 칸들을 편집·업로드 가능으로 열었고, 2.0 은 화주 설정과 관계없이 늘 연다(LOGISPRD-16194).
import type { core } from '@musinsa/pbo-core'

/** 비고·송장·수하인·판매업체·반송번호·브랜드 — 저장 요청(toItemBody)이 이미 셀 값을 싣는 칸이다 */
export const FREE_TEXT_EDIT_KEYS: ReadonlySet<string> = new Set(['PROC_NM', 'REF_NO3', 'TRS_NM', 'SAL_CHANNEL', 'TRS_INVOICE_NO', 'BRD_NM'])

/** 생성본이 편집기를 정하지 않은 칸만 입력칸으로 바꾼다 — 재핸드오프로 생성본이 편집기를 주면 그쪽을 따른다 */
export const openFreeTextColumns = (columns: core.CoreColumnType[]): core.CoreColumnType[] =>
  columns.map((column) =>
    typeof column.dataIndex === 'string' && FREE_TEXT_EDIT_KEYS.has(column.dataIndex) && !column.variant
      ? ({ ...column, variant: 'input' } as core.CoreColumnType)
      : column,
  )
